module.exports = __webpack_public_path__ + "assets/img/sendword.f37100d7.png";